import React, { useEffect, useState } from 'react';
import { Workbox } from 'workbox-window';

const SERVICE_WORKER_FILE = '/serviceworker.js';

const ServiceWorkerRegistration = () => {
    // Stan do zarządzania powiadomieniem o aktualizacji
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState(null);

    useEffect(() => {
        // Sprawdzanie wsparcia dla Service Workera i środowiska produkcyjnego
        if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
            const wb = new Workbox(SERVICE_WORKER_FILE);

            // Obsługa oczekującego Service Workera
            wb.addEventListener('waiting', (event) => {
                console.log('New Service Worker is waiting to activate');
                setUpdateAvailable(true);
                setWaitingWorker(event.sw);
            });

            // Obsługa instalacji nowego Service Workera
            wb.addEventListener('installed', (event) => {
                console.log('Service Worker installed');
                if (event.isUpdate) {
                    console.log('Service Worker updated');
                    // Wysyłamy wiadomość SKIP_WAITING, jeśli nie ma oczekującego Service Workera
                    if (!waitingWorker) {
                        wb.messageSW({ type: 'SKIP_WAITING' });
                    }
                }
            });

            // Obsługa aktywacji Service Workera
            wb.addEventListener('controlling', () => {
                console.log('Service Worker is now controlling the page');
                // Automatyczne odświeżenie strony po aktywacji
                window.location.reload();
            });

            // Obsługa błędów Service Workera
            wb.addEventListener('redundant', () => {
                console.warn('Service Worker became redundant');
            });

            // Rejestracja Service Workera
            wb.register()
                .then((registration) => {
                    console.log('Service Worker registered:', registration);
                    // Sprawdzenie, czy istnieje oczekujący Service Worker
                    if (registration.waiting) {
                        setUpdateAvailable(true);
                        setWaitingWorker(registration.waiting);
                    }
                })
                .catch((error) => {
                    console.error('Service Worker registration failed:', {
                        error,
                        file: SERVICE_WORKER_FILE,
                    });
                });

            // Nasłuchiwanie wiadomości od Service Workera
            const messageHandler = (event) => {
                if (event.data && event.data.type === 'UPDATE_AVAILABLE') {
                    console.log('New Service Worker update available');
                    setUpdateAvailable(true);
                }
            };
            navigator.serviceWorker.addEventListener('message', messageHandler);

            // Czyszczenie nasłuchiwania zdarzeń przy odmontowaniu
            return () => {
                navigator.serviceWorker.removeEventListener('message', messageHandler);
            };
        }
    }, []);

    // Funkcja do ręcznej aktywacji Service Workera
    const handleUpdate = () => {
        if (waitingWorker) {
            waitingWorker.postMessage({ type: 'SKIP_WAITING' });
            setUpdateAvailable(false);
            setWaitingWorker(null);
        }
    };

    // Renderowanie powiadomienia o aktualizacji (przykład)
    // return updateAvailable ? (
    //     <div style={{ position: 'fixed', bottom: 20, right: 20, padding: 10, background: '#fff', border: '1px solid #ccc' }}>
    //         <p>Nowa wersja aplikacji jest dostępna!</p>
    //         <button onClick={handleUpdate}>Zaktualizuj</button>
    //     </div>
    // ) : null;
};

export default React.memo(ServiceWorkerRegistration);